import _ from "lodash";
import Api from "services/Api";
import moment from 'moment';
import store from 'store/index';
import dependency from 'store/modules/fatal/dependency/index';
import estate from 'store/modules/fatal/estate/index';

const mutationTypes = {
    LOADING_CLAIM: 'LOADING_CLAIM',
    UPDATING_TABLE: 'UPDATING_TABLE',
    CHANGE_CLAIM_ID: 'CHANGE_CLAIM_ID',
    FINISHED_LOADING_CLAIM: 'FINISHED_LOADING_CLAIM',
};

// Initial State
const state = {
    claimId: null,
};

// Getters
const getters = {};

// Actions
const actions = {};

// Mutations
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        dependency,
        estate,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/fatal/index.js